/** @jsx jsx */
import { Fragment } from 'preact';
import { jsx, css } from '@emotion/react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { useTheme, CacheProvider } from '../../../providers';
const CSS = {
    BadgeImage: () => {
        return css({
            maxHeight: '100%',
            maxWidth: '100%',
        });
    },
};
export const BadgeImage = observer((properties) => {
    const globalTheme = useTheme();
    const props = {
        // default props
        // global theme
        ...globalTheme?.components?.badgeImage,
        // props
        ...properties,
        ...properties.theme?.components?.badgeImage,
    };
    const { label, url, tag, disableStyles, className, style } = props;
    const styling = {};
    if (!disableStyles) {
        styling.css = [CSS.BadgeImage(), style];
    }
    else if (style) {
        styling.css = [style];
    }
    return url ? (jsx(CacheProvider, null,
        jsx("img", { ...styling, className: classnames('ss__badge-image', `ss__badge-image--${tag}`, className), alt: label || `${tag} badge`, src: url }))) : (jsx(Fragment, null));
});
